import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icons/Icon';

const PlaceHolderImageWithButton = ({ onClick, children }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="relative w-full h-full inline-block"
      aria-label="Upload Image"
    >
      {children}
      <div className="absolute inset-0 z-10 flex items-center justify-center">
        <div className="bg-vamos-gray bg-opacity-50 rounded-full p-2">
          <Icon name="edit_image" className="w-fit h-fit" />
        </div>
      </div>
    </button>
  );
};

PlaceHolderImageWithButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default PlaceHolderImageWithButton;
